var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnersBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 919,
    height: 897,
    viewBox: "0 0 919 897",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M655.246 897L632.586 543.12L1031.02 666.127L762.88 380.373L1099 107.867L613.703 274.399L497.806 0L453.196 274.399L75.5326 211.061L360.668 380.373L0 565.772L377.663 522.304L258.699 794.81L475.856 588.538L655.246 897Z",
    fill: "url(#paint0_linear_129_1961)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_129_1961",
    x1: 22,
    y1: 555.5,
    x2: 790,
    y2: 123.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#115EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#115EF3",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnersBg);
export default __webpack_public_path__ + "static/media/partners-bg.79cccb5b6e438088bdeb83f52ac5781b.svg";
export { ForwardRef as ReactComponent };